// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jj-0";
export var fileCarousel = "_jj-2";
export var removeFileButton = "_jj-1";